import * as React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../mixins/translate/translate';
import { Content, Panel, PanelBody, PanelTopHeading, Topbar, TopbarCrumbActive, TopbarLeft, Tray } from '../elements';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Forbidden() {
    const translate = useTranslate();
    return (
        <>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title="Authorization" icon="fa-lock" />
                </TopbarLeft>
            </Topbar>
            <Content>
                <Tray>
                    <Panel small={true} topBorder={true}>
                        <PanelTopHeading>{translate('errorPages.authorizationTitle')}</PanelTopHeading>

                        <PanelBody>
                            <p>{translate('errorPages.authorizationBody')}</p>
                            <p>
                                {translate('errorPages.authorizationBody2')}&#32;
                                <Link to="/dashboard">{translate('errorPages.goToDashboard')}</Link>.
                            </p>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
